import React from 'react';
import {useStyles} from "./styles/MemberTableStyle";
import {
    Box,
    Button,
    Typography,
    IconButton,
    FormControl, Select, MenuItem, Dialog,
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import { ReactComponent as ArrowDownIcon } from '../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as DialogCloseIcon } from '../../../common/images/DialogCloseIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {COMMON_UTIL} from "../../../common/util/common.util";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function UploadDetail(props) {
    const classes = useStyles();
    const {intl} = props;
    const {userStore, authStore} = props;
    const userType = authStore.getUserType();
    const open = userStore.uploadDetailDialogOpen;

    const handleClose = () => {
        userStore.setUploadDetailDialogOpen(false);
    }

    const handleChangeLocaleCode = (e) => {
        const localeCode = e.target.value;
        let uploadDetail = Object.assign({}, userStore.uploadDetail);
        uploadDetail.localeCode = localeCode;
        uploadDetail.localeAdminUserId = ' ';
        uploadDetail.localeGroupType = ' ';
        uploadDetail.localeGroupId = ' ';
        userStore.setUploadDetail(uploadDetail);
        userStore.getLocaleAdminUserIdList(localeCode);
    }

    const handleChangeLocaleAdminUserId = (e) => {
        const localeAdminUserId = e.target.value;
        let uploadDetail = Object.assign({}, userStore.uploadDetail);
        uploadDetail.localeAdminUserId = localeAdminUserId;
        uploadDetail.localeGroupType = ' ';
        uploadDetail.localeGroupId = ' ';
        userStore.setUploadDetail(uploadDetail);
        userStore.getLocaleGroupList(localeAdminUserId);
    }

    const handleChangeLocaleGroupType = (e) => {
        const groupType = e.target.value;
        let uploadDetail = Object.assign({}, userStore.uploadDetail);
        uploadDetail.localeGroupType = groupType;
        uploadDetail.localeGroupId = ' ';
        userStore.setUploadDetail(uploadDetail);
    }

    const handleChangeLocaleGroupName = (e) => {
        let uploadDetail = Object.assign({}, userStore.uploadDetail);
        uploadDetail.localeGroupId = e.target.value;
        userStore.setUploadDetail(uploadDetail);
    }

    const isCompleteForm = () => {
        return  uploadDetail.localeGroupId !== ' ';
    }

    const handleClickFinish = () => {
        userStore.openFileExplorer();
    }

    const uploadDetail = userStore.uploadDetail;


    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} className={classes.dialogWrap}>
            <Box className={classes.myPageBox}>
                <Box className={classes.titleDialog} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography>{intl.formatMessage({id: "select_detail_info"})}</Typography>
                    <IconButton className={classes.iconButton} disableRipple onClick={handleClose}>
                        <DialogCloseIcon />
                    </IconButton>
                </Box>
                <div>
                    {userType === 'Admin' &&
                        <div>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}</Typography>
                                <FormControl className={classes.formControlAccount}>
                                    <Select
                                        value={uploadDetail.localeCode}
                                        onChange={handleChangeLocaleCode}
                                        IconComponent={(props) => (
                                            <Box>
                                                <ArrowDownIcon  {...props} />
                                            </Box>
                                        )}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "right"
                                            },
                                            transformOrigin:{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            },
                                            getContentAnchorEl: null,
                                            className:classes.selectPopover
                                        }}
                                    >
                                        {uploadDetail.localeCode === ' ' &&
                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                        }
                                        {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                            <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box style={{marginBottom: 20}} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "LocaleAdmin"})}</Typography>
                                <FormControl className={classes.formControlAccount}>
                                    <Select
                                        value={uploadDetail.localeAdminUserId}
                                        onChange={handleChangeLocaleAdminUserId}
                                        IconComponent={(props) => (
                                            <Box>
                                                <ArrowDownIcon  {...props} />
                                            </Box>
                                        )}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "right"
                                            },
                                            transformOrigin:{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            },
                                            getContentAnchorEl: null,
                                            className:classes.selectPopover
                                        }}
                                    >
                                        {uploadDetail.localeAdminUserId === ' ' &&
                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                        }
                                        {userStore.localeAdminUserIdList.length > 0 &&
                                            userStore.localeAdminUserIdList.map((userId, index) => (
                                                <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </div>
                    }
                    <>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                            <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}</Typography>
                            <FormControl className={classes.formControlAccount}>
                                <Select
                                    value={uploadDetail.localeGroupType}
                                    onChange={handleChangeLocaleGroupType}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin:{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className:classes.selectPopover
                                    }}
                                >
                                    {uploadDetail.localeGroupType === ' ' &&
                                        <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                    }
                                    {userStore.localeGroupList.length > 0 &&
                                        userStore.getGroupTypeList().map((type, index) => (
                                            <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                            <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_name"})}</Typography>
                            <FormControl className={classes.formControlAccount}>
                                <Select
                                    value={uploadDetail.localeGroupId}
                                    onChange={handleChangeLocaleGroupName}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin:{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className:classes.selectPopover
                                    }}
                                >
                                    {uploadDetail.localeGroupId === ' ' &&
                                        <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group"})}</MenuItem>
                                    }
                                    {userStore.localeGroupList.length > 0 &&
                                        userStore.getGroupList(uploadDetail.localeGroupType).map((group, index) => (
                                            <MenuItem key={index} value={group.id}>{group.name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    </>
                </div>
            </Box>
            <Box className={classes.groupBtn}>
                <Button style={{width: 300}} className={isCompleteForm() ? clsx(classes.inputButton, classes.inputButtonActive) : classes.inputButton} disableRipple disabled={!isCompleteForm()} onClick={handleClickFinish}>
                    <Typography>{intl.formatMessage({id: "complete"})}</Typography>
                </Button>
            </Box>
        </Dialog>
    );
}

export default inject('userStore', 'authStore')(injectIntl(observer(UploadDetail)));
